import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 3
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 2
  }
};

function Slider(props) {
  const { videos = [], onThumbnailClick, currentVideo } = props;

  return (
    <Carousel
      responsive={responsive}
    >
      {videos.map((video) =>
        <div key={video.source} className={`VideoThumbnailWrapper ${video.source === currentVideo ? 'Selected' : ''}`} onClick={(event) => onThumbnailClick(event, videos, video.source)} role="presentation">
          <div
            className='VideoThumbnail'
            style={{ backgroundImage: `url(${video.thumbnail})` }}
          >
            <span className="PlayButton" />
          </div>
          <span className="VideoCaption">{video.caption}</span>
        </div>
      )}
    </Carousel>
  );
}

export default Slider;
